import { useQuery } from '@tanstack/react-query';
import api from '@pasqal/core/api';

/**
 * Get the job info to fetch the sequence
 */
export const useFetchJob = (jobId?: string) => {
  return useQuery({
    queryKey: [jobId],
    queryFn: async () => {
      const response = await api.jobs.fetchJob({ id: jobId as string });
      return response.data;
    },
    enabled: !!jobId
  });
};
